module.exports = __webpack_public_path__ + "img/dice-six.2e03829b.svg";